import Swiper from 'swiper/bundle';
export default class CarouselVariants {
    constructor() {
        this.carousel = {
            element: document.querySelector('.carousel[data-carousel="variants"]'),
        }

        this.createCarousel(this.carousel.element); // Init Carousel
    }

    createCarousel(target) {
        var carousel = new Swiper(target, {
            slidesPerView: 'auto',
            spaceBetween: 0,
            grabCursor: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
            },
        });

        if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
            target.setAttribute('data-draggable',true)
        }
    }
}